// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__qmCd2","holder":"styles_holder__57PXy","count":"styles_count__5nKWE","removeWrapper":"styles_removeWrapper__YbQR6"};